module.exports = __webpack_public_path__ + "img/NF.6860552f.svg";